const isDevelopment = process.env.NODE_ENV !== 'production';

const config = {
  api: {
    baseURL: isDevelopment ? 'http://localhost:3001' : 'https://api.eqemblem.com'
  },
  auth0: {
    enabled: true,
    domain: 'dev-ydr8ctpv.us.auth0.com',
    clientId: isDevelopment 
      ? 'uiufWlhWd4nkl0ll4EYZDogaKOjlQDT8'  // Development
      : 'pY1jDF4tidvtVjju9c1B6ShC1l2rFtMz',  // Production
    audience: 'eq-emblem-api'
  }
};

export default config; 